"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/TripAdvisor.tsx
function TripAdvisor(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M7.356 13.432c0 .505-.411.91-.913.91a.912.912 0 01-.914-.91.915.915 0 011.827 0zm10.12-.91a.912.912 0 00-.913.91c0 .505.41.91.913.91.502 0 .914-.41.914-.91s-.407-.91-.914-.91zm3.415 5.31a5.52 5.52 0 01-7.729-.934l-1.181 1.764-1.177-1.75a5.513 5.513 0 01-7.556.992 5.472 5.472 0 01-1.172-7.666A7.004 7.004 0 001 8.064h3.448a13.702 13.702 0 017.528-2.06 13.4 13.4 0 017.341 2.032l3.673.004a7.008 7.008 0 00-1.08 2.193 5.477 5.477 0 01-1.02 7.6zm-9.986-4.352A4.388 4.388 0 006.51 9.099a4.388 4.388 0 00-4.396 4.38 4.388 4.388 0 004.396 4.382c2.43 0 4.395-1.96 4.395-4.381zM12 13.084c.206-2.794 2.501-4.982 5.314-5.063a12.985 12.985 0 00-5.338-1.058 13.55 13.55 0 00-5.352 1.04A5.499 5.499 0 0112 13.083zm9.613-1.096a4.398 4.398 0 00-5.643-2.594 4.376 4.376 0 00-2.602 5.625c.842 2.27 3.367 3.428 5.648 2.594a4.38 4.38 0 002.597-5.625zM9.159 13.431a2.716 2.716 0 01-2.726 2.713 2.715 2.715 0 01-2.716-2.718 2.715 2.715 0 012.726-2.707 2.724 2.724 0 012.716 2.712zm-.937 0c0-.987-.804-1.778-1.789-1.778a1.778 1.778 0 10.01 3.556 1.78 1.78 0 001.779-1.778zm11.97 0a2.718 2.718 0 01-2.72 2.713 2.711 2.711 0 11.004-5.42 2.713 2.713 0 012.717 2.707zm-.932 0c0-.982-.799-1.778-1.784-1.778s-1.784.796-1.784 1.778.799 1.778 1.784 1.778 1.78-.796 1.784-1.778z"
  }));
}
var TripAdvisor_default = TripAdvisor;

exports.TripAdvisor_default = TripAdvisor_default;
